import { ApolloClient, InMemoryCache, split, HttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getMainDefinition } from '@apollo/client/utilities';
import { link, socketLink } from "./gql-link";
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { store } from '../app/store';

const httpLink = new HttpLink({
  uri: link,
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: socketLink,
  })
);

const authLink = setContext((_, { headers }) => {
  const token = store?.getState()?.token?.token;
  // console.log(
  //   `%c [ApolloClient - authLink] Current token: ${token}`,
  //   "color: #009688; font-weight: bold;"
  // );
  const authHeader = token ? `Bearer ${token}` : "";
  // console.log(
  //   `%c [ApolloClient - authLink] Setting authorization header: ${authHeader}`,
  //   "color: #00796B; font-weight: bold;"
  // );
  return {
    headers: {
      ...headers,
      authorization: authHeader,
    },
  };
});

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    const isSubscription =
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription';
    // console.log(
    //   `%c [ApolloClient - splitLink] Using ${isSubscription ? 'wsLink' : 'httpLink'} for query.`,
    //   "color: #3F51B5; font-weight: bold;"
    // );
    return isSubscription;
  },
  wsLink,
  httpLink
);

const client = new ApolloClient({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: defaultOptions,
});

// console.log(
//   `%c [ApolloClient] Client initialized with options: ${JSON.stringify(defaultOptions)}`,
//   "color: #673AB7; font-weight: bold;"
// );

export default client;
